import Vue from 'vue';

export default {
  state: {
    reasons: [
        {
            'id': 0,
            'name': 'Ninguno',
        }
    ],
  },
  getters: {
    noPaymentReasons(state) {
      return state.reasons;
    },
  },
  mutations: {
    SET_REASONS(state, payload) {
      state.reasons = state.reasons.concat(payload);
    },
  },
  actions: {
    GET_NO_PAYMENT_REASONS(context) {
      return Vue.axios.get(`no_payment_reasons/${Vue.auth.user().company_id}`).then((response) => {
        context.commit('SET_REASONS', response.data);
      });
    },
  },
};


// WEBPACK FOOTER //
// ./src/store/modules/no_payment_reasons.js